import {
	Combobox,
	ComboboxInput,
	ComboboxButton,
	Label,
	ComboboxOption,
	ComboboxOptions,
	Transition,
} from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { Fragment } from 'react'

type Props = {
	options: Array<{ label: string; value: string; id: string }>
	renderDisplayValue: (item: { label: string; value: string; id: string }) => string
	onSelection: (e: any) => any
	onTextChange: (e: any) => any
	clearTextInput?: () => any
	placeholder: string
	label?: string
	name?: string
	defaultValue?: string
}

export default function ComboBox(props: Props) {
	return (
		<div>
			<Combobox
				onChange={value => {
					props.onSelection(value)
				}}
			>
				<Label>{props.label ?? props.label}</Label>
				<div className="relative mt-1">
					<div className="relative w-full cursor-default overflow-hidden rounded-lg text-left shadow-md sm:text-sm">
						<ComboboxInput
							defaultValue={props.defaultValue}
							placeholder={props.defaultValue}
							className="w-full rounded-lg bg-black p-2 pl-4 text-[1rem] leading-6 text-white"
							displayValue={item => {
								if (!item) return
								else props.renderDisplayValue(item)
							}}
							onChange={props.onTextChange}
							autoComplete="false"
							name={props.name}
						/>
						<ComboboxButton className="absolute inset-y-0 right-0 flex items-center pr-2">
							<ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
						</ComboboxButton>
					</div>
					<Transition
						as={Fragment}
						leave="transition ease-in duration-100"
						leaveFrom="opacity-100"
						leaveTo="opacity-0"
						afterLeave={() => null}
					>
						<ComboboxOptions
							className="max-h-60 w-[300px] rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm"
							anchor="bottom start"
						>
							{props.options.length === 0 && value !== '' ? (
								<div
									key={'test'}
									className="relative cursor-default select-none px-4 py-2 text-gray-700"
								>
									Nothing found.
								</div>
							) : (
								props.options.map(item => (
									<ComboboxOption
										key={item.id}
										className={({ active }) =>
											`relative cursor-default select-none py-2 pl-10 pr-4 ${
												active ? 'bg-primary-foreground text-white' : 'text-gray-900'
											}`
										}
										value={item}
									>
										{({ selected, active }) => (
											<>
												<span
													className={`block truncate ${selected ? 'font-medium' : 'font-normal'}`}
												>
													{item.label}
												</span>
												{selected ? (
													<span
														className={`absolute inset-y-0 left-0 flex items-center pl-3 ${
															active ? 'text-white' : 'text-primary-foreground'
														}`}
													>
														<CheckIcon className="h-5 w-5" aria-hidden="true" />
													</span>
												) : null}
											</>
										)}
									</ComboboxOption>
								))
							)}
						</ComboboxOptions>
					</Transition>
				</div>
			</Combobox>
		</div>
	)
}
